import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import platformData from '../data/platforms.json';
import { useNavigate } from "react-router-dom";

const WhereToBuy = () => {
    const platform = platformData.platforms;
    const navigate = useNavigate();

    const handlePlatformClick = (url) => {
        navigate(url);
    };

    return (
        <section
            id="where-to-buy"
            className="min-h-screen flex flex-col justify-center pt-20 pb-12 bg-cover bg-center relative"
            style={{ backgroundImage: 'url("/Images/products-background.jpg")' }}
        >
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex flex-col gap-16 md:gap-8 lg:gap-12">

                {/* Header Section */}
                <div className="flex flex-col items-center justify-center space-y-4 text-center md:justify-between">
                    <p className="text-lg sm:text-xl lg:text-2xl text-white font-montserrat font-thin">
                        Bulundugumuz Pazarlar
                    </p>
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white font-montserrat leading-tight uppercase">
                        Nereden Alınır
                    </h2>
                    <p className="text-sm sm:text-base lg:text-lg text-white font-montserrat max-w-3xl leading-relaxed">
                        Türkiye'deki tüm dijital pazarlardan ZENON Gaming ürünlerine ulaşabilirsiniz
                    </p>
                </div>

                {/* Swiper Section */}
                <div className="w-full max-w-7xl mx-auto">
                    <Swiper
                        spaceBetween={20}
                        slidesPerView={1}
                        navigation={true}
                        // pagination={{ clickable: true }}
                        modules={[Navigation, Pagination]}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 15
                            },
                            640: {
                                slidesPerView: 1,
                                spaceBetween: 20
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 25
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 30
                            }
                        }}
                        className="w-full py-4"
                    >
                        {platform.map((platform) => (
                            <SwiperSlide key={platform.id}>
                                <div
                                    className=" p-4 sm:p-3 flex flex-col  cursor-pointer transform hover:scale-105 transition-all duration-300"
                                    onClick={() => window.open(platform.url, "_blank", "noopener,noreferrer")}
                                >
                                    <div className="flex flex-col items-center justify-center">
                                        <img src={platform.logo} alt={platform.name} className="h-48 object-contain" />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}


                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default WhereToBuy;